import { ShieldCheck, TestTube } from '@phosphor-icons/react';

export function SandboxPage(): JSX.Element {
  return (
    <main className="space-y-biz-section">
      <section className="rounded-biz-card border border-biz-border bg-biz-surface p-biz-section shadow-biz-sm">
        <div className="flex items-start gap-biz-content-lg">
          <div className="rounded-biz-card bg-biz-info-subtle p-biz-content-lg text-biz-info">
            <TestTube size={28} weight="duotone" />
          </div>
          <div>
            <p className="text-biz-xs font-semibold uppercase tracking-wide text-biz-muted-foreground">
              Business Sandbox
            </p>
            <h1 className="mt-1 text-biz-2xl font-semibold text-biz-foreground">
              Config Simulator ve Mock Dispatch
            </h1>
            <p className="mt-biz-content max-w-3xl text-biz-sm text-biz-muted-foreground">
              Sandbox modu gerçek ödeme, bildirim ve webhook çıkışlarını bastırır;
              policy/profile testleri izole cache namespace altında çalışır.
            </p>
          </div>
        </div>
      </section>

      <section className="grid gap-biz-content-lg md:grid-cols-3">
        {[
          ['notification', 'Bildirimler gönderilmez, audit event olarak kaydedilir.'],
          ['payment', 'Payment capture tetiklenmez, mock intent sonucu üretilir.'],
          ['webhook', 'Dış webhook çağrıları bastırılır, correlationId ile izlenir.'],
        ].map(([title, body]) => (
          <article
            key={title}
            className="rounded-biz-card border border-biz-border bg-biz-surface p-biz-content-lg"
          >
            <ShieldCheck size={22} className="text-biz-success" />
            <h2 className="mt-biz-content font-semibold text-biz-foreground">{title}</h2>
            <p className="mt-1 text-biz-sm text-biz-muted-foreground">{body}</p>
          </article>
        ))}
      </section>
    </main>
  );
}
